import { SET_NOTIFICATIONS_COUNT, SET_UNREAD_COMMS_COUNT } from "./actions"

const INITIAL_STATE = {
  count: 0,
  unreadComms: 0,
}

export default function notificationsReducer(
  state = INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case SET_NOTIFICATIONS_COUNT:
      return { ...state, count: action.count }
    case SET_UNREAD_COMMS_COUNT:
      return { ...state, unreadComms: action.unreadComms }
    // We can do case for setting actual notifications objects
    default:
      return state
  }
}
